import { ListBookedConsultationsRequest } from '@taxfyle/api-internal/internal/consultation_pb'
import { ClaimConsultationJobRequest } from '@taxfyle/api-internal/internal/job_pb'
import { Interval } from '@taxfyle/api-internal/shared/types/interval_pb'
import { TimeRange } from 'jobs/TimeRange'
import { PickupResult } from 'opportunities/OpportunityStore'
import { ISOToTimestamp } from 'utils/grpc-util'
import { WorkAPI } from '../API'
import Consultation from './Consultation'
import { FetchJob } from 'jobs/JobStore'

export default class ConsultationStore {
  constructor(private api: WorkAPI, private refreshJob: FetchJob) {}

  /**
   * Fetch booked consultations for the current user
   *
   * @returns
   */
  async fetchBookedConsultations() {
    const result = await this.api.consultations.listBookedConsultations(
      new ListBookedConsultationsRequest()
    )
    const attrs = result.toObject()
    return attrs.appointmentsList.map((c) =>
      Consultation.fromJSON({
        providerUserPublicId: c.proPublicId,
        clientUserPublicId: c.clientPublicId,
        ...c,
      })
    )
  }

  /**
   * Claims a consultation job
   *
   * @param id
   * @param bookedTime
   * @returns
   */
  async pickupConsultationJob(id: string, bookedTime: TimeRange) {
    await this.api.jobsV3.claimConsultationJob(
      new ClaimConsultationJobRequest()
        .setId(id.toString())
        .setBookedTime(
          new Interval()
            .setStartTime(ISOToTimestamp(bookedTime.startTime.toISOString()))
            .setEndTime(ISOToTimestamp(bookedTime.endTime.toISOString()))
        )
    )

    await this.refreshJob(id)

    return PickupResult.Success
  }
}
